import { basicEnum } from "./base";

export const CapacityUnitEnum = basicEnum([
    {
        label: "Mbps",
        value: "Mbps",
    },
    {
        label: "Gbps",
        value: "Gbps",
    },
    {
        label: "Port",
        value: "Port",
    },
]);

export namespace CapacityUnitEnum {
    export type Labels = (typeof CapacityUnitEnum)["labels"][number];
    export type Values = (typeof CapacityUnitEnum)["values"][number];
}
